/** @format */

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
  status: string;
}
export default function CircularLoader({ status }: Props) {
  return (
    <>
      {status === 'loading' && (
        <Box style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress  />
        </Box>
      )}
    </>
  );
}
